/** Help §5.1 — Logging in (`auth/LoginView.tsx`). */
import { helpSectionMeta } from '../help-sections.js';
import { Btn, HelpSectionCard, Li, Shot, Steps } from '../HelpPrimitives.js';

export function Login(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('login')}>
      <Steps>
        <Li>Open the app link in your browser.</Li>
        <Li>
          Enter your <Btn>Email</Btn> and <Btn>Password</Btn>.
        </Li>
        <Li>
          Click <Btn>Log in</Btn> — it shows <Btn>Logging in…</Btn> while it checks your
          credentials.
        </Li>
      </Steps>
      <Shot slug="login" caption="The sign-in screen: Email, Password and the Log in button." />
    </HelpSectionCard>
  );
}
